import { forwardRef } from 'react'
import { Box, Icon, Text } from '@/components/lib'

const statusColors = {
  info: { bg: 'blue.100', bgDark: 'blue.900', icon: 'blue.600', iconDark: 'blue.300', hoverBg: 'blue.200', hoverBgDark: 'blue.800' },
  warning: { bg: 'orange.100', bgDark: 'orange.900', icon: 'orange.600', iconDark: 'orange.300', hoverBg: 'orange.200', hoverBgDark: 'orange.800' },
  error: { bg: 'red.100', bgDark: 'red.900', icon: 'red.600', iconDark: 'red.300', hoverBg: 'red.200', hoverBgDark: 'red.800' },
  success: { bg: 'green.100', bgDark: 'green.900', icon: 'green.600', iconDark: 'green.300', hoverBg: 'green.200', hoverBgDark: 'green.800' }
}

const NavBubble = forwardRef(function NavBubble ({ icon, status = 'info', badge, ...props }, ref) {
  const colors = statusColors[status] || statusColors.info
  const badgeLabel = badge > 99 ? '99+' : badge > 9 ? '9+' : badge

  return (
    <Box
      ref={ref}
      {...props}
      rounded='full'
      bg={colors.bg}
      _dark={{ bg: colors.bgDark }}
      _hover={{ bg: colors.hoverBg, _dark: { bg: colors.hoverBgDark } }}
      p={1}
      w='30px'
      h='30px'
      display='flex'
      justifyContent='center'
      alignItems='center'
      position='relative'
      cursor='pointer'
      transition='background 0.15s'
    >
      <Icon color={colors.icon} _dark={{ color: colors.iconDark }} as={icon} />
      {badge > 0 && (
        <Box
          rounded='full'
          minW='15px'
          h='15px'
          px='2px'
          bg='red.500'
          position='absolute'
          right='-8px'
          top='-3px'
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          <Text fontFamily='mono' color='fg.onAccent' fontSize='2xs' textAlign='center' lineHeight='1'>
            {badgeLabel}
          </Text>
        </Box>
      )}
    </Box>
  )
})

export default NavBubble
